import React from 'react';
import '../css/CoursesGrid.css';

const CoursesGrid = () => {
  const coursesList = [
    {
      id: 1,
      type: "standard",
      icon: "🎓",
      title: "Diploma in Fire & Safety / Industrial Safety Management",
      desc: "Comprehensive program covering industrial safety management and fire protection.",
      duration: "12 Months",
      eligibility: "12th Pass"
    },
    {
      id: 2,
      type: "standard",
      icon: "👨‍🎓",
      title: "PG Diploma in Fire & Safety / Industrial Safety",
      desc: "Advanced postgraduate program for safety leadership and management roles.",
      duration: "12 Months",
      eligibility: "Graduate"
    },
    {
      id: 3,
      type: "standard",
      icon: "🎖️",
      title: "Advanced Diploma in Industrial Safety (MSBTE)",
      desc: "Technical safety diploma recognized by the government for engineering backgrounds.",
      duration: "12 Months",
      eligibility: "B.Sc / Diploma / B.Tech"
    },
    {
      id: 4,
      type: "standout-dark", // This matches the specific blue card from image 9
      icon: "🌐",
      badgeText: "★ International Certification",
      title: "NEBOSH IGC",
      desc: "Globally recognized certification. High demand in Gulf & multinational companies.",
      tags: ["International", "Gold Partner"]
    },
    {
      id: 5,
      type: "standard",
      icon: "🛡️",
      title: "IOSH Managing Safely",
      desc: "Short-term professional course for managers and supervisors in any industry.",
      duration: "Short-term",
      eligibility: "Professional"
    }
  ];

  return (
    <section className="gfi-courses-section">
      <div className="gfi-courses-container">
        
        {/* SECTION HEADER BLOCK */}
        <div className="gfi-courses-header-block">
          <span className="gfi-section-mini-badge">OUR PROGRAMS</span>
          <h2 className="gfi-courses-main-title">Our Fire & Safety Courses</h2>
          <p className="gfi-courses-subheading">
            Diploma, Degree, NEBOSH, IOSH & Industrial Safety Courses
          </p>
        </div>

        {/* CARDS MESH GRID (3 Column Core Grid Matrix) */}
        <div className="gfi-courses-layout-grid">
          {coursesList.map((course) => {
            if (course.type === "standout-dark") {
              return (
                <div key={course.id} className="gfi-course-card standout-dark-variant">
                  <div className="gfi-dark-card-top-pill">
                    {course.badgeText}
                  </div>
                  <div className="gfi-cc-icon-box dark-accent">{course.icon}</div>
                  <h3 className="gfi-cc-title">{course.title}</h3>
                  <p className="gfi-cc-description">{course.desc}</p>
                  
                  <div className="gfi-cc-meta-row">
                    {course.tags.map((tag, i) => (
                      <span key={i} className="gfi-cc-pill-tag dark-mode-tag">
                        {tag === "Gold Partner" ? "★ " : ""}{tag}
                      </span>
                    ))}
                  </div>
                  <a href="#details" className="gfi-cc-view-link dark-link">
                    VIEW DETAILS →
                  </a>
                </div>
              );
            }

            return (
              <div key={course.id} className="gfi-course-card standard-white-variant">
                <div className="gfi-cc-icon-box blue-accent">{course.icon}</div>
                <h3 className="gfi-cc-title">{course.title}</h3>
                <p className="gfi-cc-description">{course.desc}</p>
                
                <div className="gfi-cc-meta-row">
                  <span className="gfi-cc-pill-tag">⏱ {course.duration}</span>
                  <span className="gfi-cc-pill-tag">👤 {course.eligibility}</span>
                </div>
                <a href="#details" className="gfi-cc-view-link">
                  VIEW DETAILS →
                </a>
              </div>
            );
          })}
        </div>

        {/* BOTTOM GLOBAL ACTION BUTTON (Image 9 Match) */}
        <div className="gfi-courses-footer-action">
          <a href="#all-courses" className="gfi-view-all-courses-btn">
            🎓 VIEW ALL COURSES 📥
          </a>
        </div>

      </div>
    </section>
  );
};

export default CoursesGrid;